import React from "react";
import "./Legal.css";

export default function UserPrivacy() {
  return (
    <div className="legal-page-container">
      <h1>Koala Quest Privacy Policy</h1>
      <p><strong>Last Updated:</strong> [Insert Date]</p>

      <h2>1. Information We Collect</h2>
      <p>We may collect the following information:</p>
      <ul>
        <li><strong>Parent Accounts:</strong> Name, email address, login credentials (via Firebase, Google, or Facebook).</li>
        <li><strong>Child Accounts:</strong> First name, birth date, parent code, learning progress, in-app rewards.</li>
      </ul>

      <h2>2. How We Use Your Data</h2>
      <ul>
        <li>Account authentication</li>
        <li>Linking children to parents</li>
        <li>Tracking progress and awarding tokens</li>
        <li>Sending parent codes and important updates</li>
        <li>We do NOT use data for marketing or share it with third parties</li>
      </ul>

      <h2>3. Third-Party Services</h2>
      <p>We use Firebase, Google, and Facebook services. These providers may collect device or usage data as per their own privacy policies.</p>
      <p>
        We may use the “Advanced Matching” feature of Meta Pixel for parent accounts. This securely hashes your email address before sharing with Meta (Facebook), to improve the accuracy of ad attribution and allow us to reach users who have interacted with our website. You may opt out of this at any time by contacting us.
      </p>

      <h2>4. Children's Privacy</h2>
      <p>All activity is monitored via parent account link. We do not use children’s data for advertising, remarketing, or advanced matching purposes.</p>

      <h2>5. Data Security</h2>
      <p>We use industry-standard security and encryption through Firebase and Google Cloud.</p>

      <h2>6. Your Rights</h2>
      <p>Parents can request to view or delete any data associated with their accounts or their children’s accounts by contacting us at <a href="mailto:koalaquestcanada@gmail.com">koalaquestcanada@gmail.com</a>.</p>

      <h2>7. Contact</h2>
      <p>Koala Quest Canada<br />Email: <a href="mailto:koalaquestcanada@gmail.com">koalaquestcanada@gmail.com</a><br />Website: <a href="https://koalaquest.ca">https://koalaquest.ca</a></p>

      <h2>8. Advertising and Analytics</h2>
      <p>
        We use analytics and advertising tools such as Google Analytics and Meta (Facebook) Pixel to understand website usage and improve our services. For parent accounts, certain information (such as hashed email addresses) may be shared with these platforms to improve the accuracy of conversion tracking and ad optimization. This is only done with your consent and in compliance with applicable laws. Data from child accounts is never used for advertising or tracking purposes.
      </p>
      <p>
        We may use the “Advanced Matching” feature of Meta Pixel for parent accounts. This securely hashes your email address before sharing with Meta (Facebook), to improve ad attribution and allow us to reach users who have interacted with our website. You may opt out of this at any time by contacting us.
      </p>
    </div>
  );
} 
